/**
 * 覆盖默认中文键的展示；与 en-US 键名一致。
 * IndexPc 首页等：键为内部标识时在此给出中文界面文案。
 */
export default {
  '官网菜单竞赛': '竞赛',
  '官网菜单新闻资讯': '新闻资讯',
  '官网菜单代表团': '代表团',
  '官网菜单票务': '票务',
  '官网菜单观众中心': '观众中心',
  '官网菜单商务': '商务合作',
  '官网菜单赞助商': '赞助商',
  '官网菜单城市文化': '城市与文化',
  '官网菜单世青赛全称': '世界青年锦标赛与年龄组比赛',
  '官网菜单世锦赛全称': '2026年世界蹦床锦标赛',
  '接送单价说明': '美金/人（含往返）。同一机场：计费人数 = max(到达人数合计, 离港人数合计) × 单价。',
  '接送计费人数': '计费人数',
  '到达合计': '到达合计',
  '离港合计': '离港合计',
  '站点小计': '站点小计',
  '年龄组关于赛事水印大标题': '关于比赛',
  '年龄组关于赛事章节标题': '赛事简介',
  '年龄组关于赛事小节标题': '世界青年锦标赛与年龄组比赛',
  '年龄组关于赛事段落1':
    '第3届FIG蹦床与技巧世界青年锦标赛暨第32届世界年龄组比赛将在中国南京举行，汇聚全球最具潜力的青少年蹦床运动员，共赴一场青春与实力的盛会。',
  '年龄组关于赛事段落2':
    '赛事由国际体操联合会（FIG）主办。世界青年锦标赛面向15–16岁选手，世界年龄组比赛设多个年龄组别，涵盖个人蹦床、同步蹦床、技巧、双迷你蹦床等项目，展现蹦床运动的未来之星。',
  '年龄组关于赛事段落3':
    '来自各国（地区）体操协会的年轻选手将同台竞技、争夺冠军荣誉，以精湛技艺、稳定发挥与震撼的空中表现，向世界展示蹦床运动的蓬勃生机。',
  '年龄组官网页面标题': '2026年世界青年锦标赛与年龄组比赛',
  '年龄组官网页面描述':
    '2026年FIG世界青年锦标赛与年龄组比赛（南京）— 面向青少年选手的蹦床、技巧与双迷你蹦床国际赛事。',
  '年龄组官网页脚版权': '© 2026 世界青年锦标赛与年龄组比赛 · 南京',
  '年龄组官网页脚副标题': '主办地：南京江北新区 | 2026年11月12日至15日',
  '官网新闻1日期': '2026年3月9日',
  '官网新闻2日期': '2025年10月25日',
  '官网新闻3日期': '2025年11月10日',
  '官网新闻1标题': '2026年世界蹦床锦标赛正式宣布落户南京',
  '官网新闻2标题': '国际体联秘书长赞誉中国2026南京蹦床世锦赛筹办工作',
  '官网新闻3标题': '中国蹦床队世锦赛揽四金，剑指2026南京主场',
  '官网新闻1摘要':
    '第39届FIG世界蹦床锦标赛将于11月5日至8日在南京江北新区扬子江国际会议中心举行，汇聚全球顶尖蹦床选手展开高水平竞技。',
  '官网新闻2摘要':
    '国际体联秘书长高度认可中国出色的赛事承办能力，对2026年南京蹦床世锦赛成功举办充满期待。',
  '官网新闻3摘要':
    '中国蹦床队在第38届世锦赛上夺得4金2铜，正以饱满状态备战2026年南京主场赛事。',
  '关于赛事水印大标题': '关于锦标赛',
  '关于赛事章节标题': '赛事简介',
  '关于赛事小节标题': '2026年世界蹦床锦标赛',
  '关于赛事段落1':
    '2026年世界蹦床锦标赛将在中国南京举行，汇聚全球顶尖蹦床运动员，呈现力量与艺术的精彩对决。',
  '关于赛事段落2':
    '本届赛事由国际体操联合会（FIG）主办，涵盖个人与同步等多个蹦床小项，代表世界蹦床运动的最高水平。',
  '关于赛事段落3':
    '来自50多个国家和地区的运动员将角逐世锦赛荣誉，展现高超技艺、精准技术与震撼的空中表现。',
  '官网倒计时天': '天',
  '官网倒计时时': '时',
  '官网倒计时分': '分',
  '官网倒计时秒': '秒',
  '最新新闻水印': '最新动态',
  '最新新闻标题': '新闻资讯',
  '新闻阅读更多': '阅读更多',
  '南京区块眉题': '宜居之城',
  '南京区块主标题': '欢迎来到南京江北新区',
  '南京区块小节标题': '山水相依的城区',
  '南京区块段落1':
    '长江蜿蜒如练，老山郁郁如屏，共同勾勒出新区水秀山明的画卷。背倚老山、面朝大江，这里是自然与人文交融的理想栖居地。',
  '南京区块段落2':
    '山水与城景在此和谐共生，于繁华都市中辟出一方静谧，在青山绿水间感受城市脉动。',
  '合作伙伴水印': '官方合作伙伴',
  '合作伙伴标题': '官方合作伙伴',
  '官网页面标题': '2026年世界蹦床锦标赛',
  '官网页面描述': '2026年世界蹦床锦标赛（南京）— FIG 蹦床项目官方赛事。',
  '官网页脚版权': '© 2026 世界蹦床锦标赛 南京',
  '官网页脚副标题': '主办地：南京江北新区 | 2026年11月5日至8日',
  '官网页脚敬请期待': '敬请期待！',
  '官网页脚隐私': '隐私政策',
  '官网页脚条款': '条款与条件',
  '官网页脚联系': '联系我们',
  '官网页脚媒体': '媒体',
  '登录页标题': '登录',
  '长度在11个字符': '长度须为11位',
  '长度在4个字符': '长度须为4位',
  '长度在3-16个字符': '长度须在3至16个字符之间',
  '手机号码必须为11位': '手机号码须为11位',
  '验证通过请重置密码': '验证通过，请重置密码！',
  '单位用户名密码不能为空': '单位/用户名/密码不能为空',
  '成员职能体操运动员': '体操运动员',
  '成员职能代表团团长': '代表团团长',
  '成员职能联合会主席及嘉宾': '联合会主席及嘉宾',
  '成员职能联合会主席及嘉宾VIP': '联合会主席及嘉宾 VIP',
  '成员职能医生': '医生',
  '成员职能心理健康专业人员': '心理健康专业人员',
  '激活即列出输入建议': '激活即列出输入建议',
  '激活即列出输入建议': '激活即列出输入建议',
  '人员': '人员',
  '酒店房型': '酒店/房型',
  '入住退房': '入住/退房',
  '人员1': '人员1',
  '人员2': '人员2',
  '请填写入住人员': '请填写入住人员',
  '请选择入住人员': '请选择或输入入住人员',
  '请选择人员1和人员2': '请选择人员1和人员2',
  '请填写人员1和人员2': '请填写人员1和人员2',
  '同一房间不能选择相同人员': '同一房间不能选择相同人员',
  '复制': '复制',
  '房间数': '房间数',
  '成员职能嘉宾': '嘉宾',
  '成员职能嘉宾VIP': '嘉宾 VIP',
  '成员职能蹦床队经理': '蹦床队经理 (TRA)',
  '成员职能蹦床教练': '蹦床教练 (TRA)',
  '成员职能蹦床医务保障': '蹦床医务保障 (TRA)',
  '成员职能蹦床高级裁判': '蹦床高级裁判 (TRA)',
  '成员职能技巧队经理': '技巧队经理 (TUM)',
  '成员职能技巧教练': '技巧教练 (TUM)',
  '成员职能技巧医务保障': '技巧医务保障 (TUM)',
  '成员职能技巧高级裁判': '技巧高级裁判 (TUM)',
  '成员职能双杠队经理': '双杠队经理 (DMT)',
  '成员职能双杠教练': '双杠教练 (DMT)',
  '成员职能双杠医务保障': '双杠医务保障 (DMT)',
  '成员职能双杠高级裁判': '双杠高级裁判 (DMT)',
  '签证政策参考': '签证政策参考（供代表团查阅）',
  '签证参考互免协定一览': "List of Agreements on Mutual Visa Exemption Between the People's Republic of China and Foreign Countries",
  '签证参考单方面免签': '单方面免签政策常见问题解答 FAQs on Visa-free Entry into China',
};



// WEBPACK FOOTER //
// ./src/i18n/messages/zh-CN.js